import React, { useEffect } from 'react';
import { FiltersBarContainer, FiltersDrawerStickyBar, filtersDrawerStyles, FiltersTitle } from '@styles/search-layout';
import { Drawer, Backdrop } from '@mui/material';
import { Theme, ThemeProps } from '@theme/base';
import { withTheme } from '@emotion/react';
import { TestId } from '@components/test-ids';
import { Button, ButtonColor, ButtonSize } from '@components/material-ui';
import { useI18NextContext } from '@components/hooks';
import { ZIndex } from '@styles/z-index';
import { css } from '@emotion/css';
import { setBodyNoScroll } from '@util/common';
import { mq } from '@styles/breakpoints';
import styled from '@emotion/styled';
import { mixins } from '@styles/mixins';

export interface FiltersMobileDrawerProps {
  onClose: (show?: boolean) => void;
  onReset: () => void;
  hasAppliedFilters: boolean;
  renderFilters: (props: any) => any;
  open: boolean;
  theme?: Theme;
  count: number;
}

const backdropStyles = css({
  ['&.MuiBackdrop-root']: {
    zIndex: ZIndex.BACKDROP,

    [mq.medium]: {
      display: 'none'
    }
  }
});

const Reset = styled.a(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  ...mixins(theme).link,
  fontWeight: 500
}));

export const FiltersMobileDrawerComponent = ({
  open,
  onClose,
  theme,
  count,
  hasAppliedFilters,
  onReset,
  renderFilters
}: FiltersMobileDrawerProps) => {
  const t: any = useI18NextContext();

  /* *** HOOKS *** */
  useEffect(() => {
    setBodyNoScroll(open, true);

    return () => {
      setBodyNoScroll(false);
    };
  }, [open]);

  return (
    <>
      <Backdrop className={backdropStyles} open={open} onClick={() => onClose(false)} />
      <Drawer
        data-testid={TestId.filters.filtersMobileDrawer}
        classes={filtersDrawerStyles}
        anchor="right"
        open={open}
        onClose={() => onClose(false)}
      >
        <FiltersBarContainer>
          <FiltersDrawerStickyBar>
            <FiltersTitle>
              {count} {t('filters__drawer-button--label')}{' '}
              {hasAppliedFilters && <Reset onClick={onReset}>(reset)</Reset>}
            </FiltersTitle>
            <Button
              color={ButtonColor.SECONDARY}
              testId={TestId.filters.filtersApplyButton}
              onClick={() => onClose(false)}
              size={ButtonSize.SMALL}
              label={t('common__label--done')}
              backgroundColor={theme!.custom.colors.white}
            />
          </FiltersDrawerStickyBar>
          {renderFilters({ title: false })}
        </FiltersBarContainer>
      </Drawer>
    </>
  );
};

export const FiltersMobileDrawer = withTheme(FiltersMobileDrawerComponent);
